import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Suppress ResizeObserver loop errors (common in Material-UI apps)
const resizeObserverErrMsgPattern = /ResizeObserver loop completed with undelivered notifications/;
const consoleError = console.error;
console.error = (...args) => {
  if (typeof args[0] === 'string' && resizeObserverErrMsgPattern.test(args[0])) {
    return; // Ignore ResizeObserver errors
  }
  consoleError(...args);
};

// Prevent dev error overlay from breaking UI on this known browser ResizeObserver warning.
window.addEventListener(
  'error',
  (event) => {
    if (resizeObserverErrMsgPattern.test(event?.message || '')) {
      event.stopImmediatePropagation();
    }
  },
  true
);

window.addEventListener('unhandledrejection', (event) => {
  const reason = String(event?.reason || '');
  if (resizeObserverErrMsgPattern.test(reason)) {
    event.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
